export default __webpack_public_path__ + "static/media/mobileNav.cb3ceb46.png";